import React, { useEffect } from "react";
import { Card, Col, Container, Row } from "reactstrap";
import ServiceProviderList from "./ServiceProviderList";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

const ServiceProvider = () => {
  const breadcrumbItems = [
    { title: "PSP", link: "" },
    { title: "Product/Service Provider", link: "/psp/psp" },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb items={breadcrumbItems} />
          <Card className="card_container">
            <ServiceProviderList />
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ServiceProvider;
